export const baseUrl_ = process.env.REACT_APP_TBH_BACKEND_API;
export const swqtk = process.env.REACT_APP_PAYMENT_GATEWAY_API;
export const landingPageUrl = process.env.REACT_APP_TBH_FRONTEND_URL;
export const dashboardPageUrl = process.env.REACT_APP_TBH_DASHBOARD_FRONTEND_URL;
export const timeout = Number(process.env.REACT_APP_TIMEOUT);
export const bsf = process.env.REACT_APP_BSF_URL_API;
export const norebaseUrl = process.env.REACT_APP_NOREBASE_NAME_CHECK;

export const Colors = {
  green: '#028789',
  black: '#212121',
  gray: '#D6D9E0',
  white: 'white',
  secondaryGreen: '#059964',
  secondaryGreen300: '#D4D9E0',
};
